// @module Ames.ConfigurableItems.COnfigurablePDP
define("Ames.ConfigurableItems.COnfigurablePDP.View", [
  "ames_configurableitems_configurablepdp.tpl",

  "Ames.ConfigurableItems.COnfigurablePDP.SS2Model",

  "Backbone",

  "underscore",

  "Item.Model",

  "Session",

  "Configuration",
], function (
  ames_configurableitems_configurablepdp_tpl,

  COnfigurablePDPSS2Model,

  Backbone,

  _,

  ItemModel,

  Session,

  Configuration
) {
  "use strict";

  // @class Ames.ConfigurableItems.COnfigurablePDP.View @extends Backbone.View
  return Backbone.View.extend({
    template: ames_configurableitems_configurablepdp_tpl,

    initialize: function (options) {
      this.pdp = options.container.getComponent("PDP");

      var cart = options.container.getComponent("Cart");

      this.layout = options.container.getComponent("Layout");

      var self = this;

      var userProfile = options.container.getComponent("UserProfile");

      var itemInfo = this.pdp.getItemInfo();

      this.isConfigurable = itemInfo.item.custitem_option1description
        ? true
        : false;

      this.isLoggedIn = false;

      this.itemModel = new ItemModel();

      this.itemOptionsMapped = {};

      this.options = [];

      this.updatedPrice = this.pdp.getPrice().price;

      this.updatedDescription = "";

      userProfile.getUserProfile().done(function (profile) {
        if (profile.isloggedin) {
          if (self.isConfigurable) {
            // clean options from previous configurations
            self.pdp.setOption(
              "custcol_custom_price",
              self.updatedPrice.toString()
            );
            self.pdp.setOption(
              "custcol_configurable_description",
              self.updatedDescription
            );
            self.itemOptionsMapped = self.mapItemOptions(itemInfo.item);
            self.isLoggedIn = true;
          }
        } else {
          self.isLoggedIn = false;
        }
        self.render();
      });

      this.layout.on("afterShowContent", function () {
        $(".custcol_configurable_description-controls-group").hide();
      });

      this.optionsDicc = {};
    },

    events: {
      'change [data-action="select-option"]': "onChangeOption",
    },

    onChangeOption: function (e, isInit) {
      var dataPrice = 0;
      var dataItemId = null;
      var optionValue = "";
      var optionTitle = "";
      var optionIndex = null;

      // ------------------------------
      // 1. Extract values depending on mode (UI event or auto-init)
      // ------------------------------
      if (!isInit) {
        const $target = jQuery(e.target);
        const selected = $target.find(":selected");

        dataPrice = parseFloat(selected.data("price")) || 0;
        dataItemId = selected.data("item-id");
        optionValue = selected.val();
        optionTitle = selected.data("option-title");
        optionIndex = selected.data("option-id");
      } else {
        // auto-trigger from mapItemOptions
        dataPrice = parseFloat(e.price) || 0;
        dataItemId = e.itemId;
        optionValue = e.value;
        optionTitle = e.optionTitle;
        optionIndex = e.optionId;
      }

      // ------------------------------
      // 2. Build dictionary key
      // ------------------------------
      const optionDiccId = optionTitle + optionIndex;

      // ------------------------------
      // 3. Remove previous selection for this option
      // ------------------------------
      if (this.optionsDicc[optionDiccId]) {
        // Remove old price contribution
        const oldPrice = Number(this.optionsDicc[optionDiccId].price) || 0;
        this.updatedPrice -= oldPrice;

        // Remove old description fragment
        const pattern = new RegExp(optionTitle + ": .*? / ", "g");
        this.updatedDescription = this.updatedDescription.replace(pattern, "");
      }

      // ------------------------------
      // 4. Apply new selection (if valid)
      // ------------------------------
      if (dataItemId) {
        // Add new description fragment
        this.updatedDescription += `${optionTitle}: ${dataItemId} / `;

        // Add new price
        this.updatedPrice += dataPrice;

        // Update dictionary
        this.optionsDicc[optionDiccId] = {
          price: dataPrice,
          itemId: dataItemId,
          description: optionValue,
        };
      } else {
        // No valid selection — remove from dictionary
        delete this.optionsDicc[optionDiccId];
      }

      // Force updatedPrice to always be a number
      this.updatedPrice = Number(this.updatedPrice) || 0;

      // ------------------------------
      // 5. Push values back into PDP options
      // ------------------------------
      this.pdp.setOption("custcol_custom_price", this.updatedPrice.toString());
      this.pdp.setOption(
        "custcol_configurable_description",
        this.updatedDescription
      );

      // ------------------------------
      // 6. Mark form completed (all options selected)
      // ------------------------------
      if (this.options.length === Object.keys(this.optionsDicc).length) {
        this.pdp.setOption("custcol_form_completed", "T");
      } else {
        this.pdp.setOption("custcol_form_completed", "F");
      }
    },

    bindings: {},

    mapItemOptions: function (item) {
      var itemOptions = [];

      var itemId = item.internalid;

      // Helper functions to parse pair strings:
      function findValueForItemId(pairString, targetId) {
        if (!pairString) {
          return null;
        }
        var pairs = pairString.split(";");
        for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split(",");
          // pair[0] = ID, pair[1] = data (price or value)
          if (pair.length === 2 && pair[0].trim() === String(targetId)) {
            return pair[1].trim();
          }
        }
        return null;
      }

      // Iterate through a predefined range (assuming there are up to 16 options)
      for (var i = 1; i <= 16; i++) {
        var descriptionKey = "custitem_option" + i + "description";
        var idsKey = "custitem_option" + i + "ids";

        // Check if the description and IDs exist and are not empty
        if (item[descriptionKey] && item[idsKey]) {
          var option = {
            title: item[descriptionKey],
            index: i,
            items: [],
          };

          var ids = item[idsKey]
            .split(";")
            .map(function (id) {
              return id.trim();
            })
            .filter(Boolean); // Split and clean the IDs

          // Use IIFE to capture the current iteration's i value
          (function (index, ids, option, self) {
            self.itemModel
              .fetch({ data: { id: ids.join(",") } })
              .done(function (response) {
                var optionsValues = _.map(
                  response.items,
                  function (fetchedItem) {
                    // Parse the price and value from the fetchedItem
                    var priceStr =
                      fetchedItem["custitem_option" + index + "price"];
                    var valueStr =
                      fetchedItem["custitem_option" + index + "value"];

                    // Match the correct price and value by the internalid of the fetchedItem
                    var matchedPrice = findValueForItemId(
                      priceStr,
                      itemId.toString()
                    );
                    var matchedValue = findValueForItemId(
                      valueStr,
                      itemId.toString()
                    );

                    // "BO" (or "unavailable") in place of the price marks a
                    // component as listed but not selectable, e.g.
                    // custitem_option2price = "10878,BO" on a backordered item
                    var isUnavailable = /^(bo|unavailable)$/i.test(
                      matchedPrice || ""
                    );

                    return {
                      itemId: fetchedItem.internalid.toString(),
                      price: isUnavailable ? null : matchedPrice,
                      value: matchedValue,
                      disabled: isUnavailable,
                      optionTitle: option.title,
                      optionId: option.index,
                    };
                  }
                );
                var orderedOptionsValues = [];
                ids.forEach(function (id) {
                  var found = _.find(optionsValues, function (option) {
                    return option.itemId === id;
                  });
                  if (found) {
                    orderedOptionsValues.push(found);
                  }
                });
                option.items = orderedOptionsValues;
                if (option.items.length === 1) {
                  option.isIncluded = true;
                  self.onChangeOption(
                    {
                      itemId: option.items[0].itemId,
                      price: option.items[0].price,
                      optionTitle: option.title,
                      optionId: option.index,
                      value: option.items[0].value,
                    },
                    true
                  );
                }
                self.options.push(option);

                self.render();
              });
          })(i, ids, option, this); // Pass i and this as arguments to the IIFE
        }
      }

      return itemOptions;
    },

    getUrlLogin: function () {
      var url =
        Session.get("touchpoints.login") +
        "&origin=" +
        (Configuration.get("currentTouchpoint") || "home") +
        "&origin_hash=";

      return (
        url +
        encodeURIComponent(
          this.options.origin === "PDPQUICK"
            ? this.model.generateURL().replace("/", "")
            : Backbone.history.fragment
        )
      );
    },

    childViews: {},

    //@method getContext @return Ames.ConfigurableItems.COnfigurablePDP.View.Context
    getContext: function getContext() {
      // sort options by index
      this.options = _.sortBy(this.options, "index");
      return {
        isConfigurable: this.isConfigurable,
        options: this.options,
        isLoggedIn: this.isLoggedIn,
        urlLogin: this.getUrlLogin(),
      };
    },
  });
});
